/**
 * A simple utility to capitalize a string.
 *
 * @param s the string to capitalize
 * @returns the capitalized string
 */
export function capitalize(s) {
    if (!s || typeof s !== 'string')
        return '';
    return (s[0].toUpperCase() + s.slice(1));
}
